var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3375 7.28752C13.3375 3.72502 10.45 0.837524 6.8875 0.837524C3.325 0.837524 0.4375 3.76252 0.4375 7.28752C0.4375 10.5875 2.9125 13.2875 6.1 13.7V17.0375H4.225C3.775 17.0375 3.4375 17.375 3.4375 17.825C3.4375 18.275 3.775 18.6125 4.225 18.6125H6.1V20.375C6.1 20.825 6.4375 21.1625 6.8875 21.1625C7.3375 21.1625 7.675 20.825 7.675 20.375V18.6125H9.55C10 18.6125 10.3375 18.275 10.3375 17.825C10.3375 17.375 10 17.0375 9.55 17.0375H7.675V13.7C10.8625 13.2875 13.3375 10.5875 13.3375 7.28752ZM2.0125 7.28752C2.0125 4.58752 4.1875 2.41252 6.8875 2.41252C9.5875 2.41252 11.7625 4.58752 11.7625 7.28752C11.7625 9.98752 9.5875 12.1625 6.8875 12.1625C4.1875 12.1625 2.0125 9.98752 2.0125 7.28752Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemale);
export default __webpack_public_path__ + "static/media/GenderFemale.c1dcf9ea7a01cd096ec378581bb76f4d.svg";
export { ForwardRef as ReactComponent };